import type { FirebaseConfigType } from './type';

export const FirebaseConfig: FirebaseConfigType = {
  apiKey: 'AIzaSyDdyUe0yNHkwqed1YYt_mlpi6W39Q0gUuo',
  authDomain: 'levii-balus-playground-1.firebaseapp.com',
  databaseURL: 'https://levii-balus-playground-1-default-rtdb.firebaseio.com',
  projectId: 'levii-balus-playground-1',
  storageBucket: 'levii-balus-playground-1.appspot.com',
  messagingSenderId: '637349554366',
  appId: '1:637349554366:web:628e059f3352284a9456ef',
  measurementId: 'G-0M4NJBBFVG',
};
